var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-wrapper"},[_c('div',{staticClass:"history-content"},[_vm._v(" History coming soon ")]),_c('div',{staticClass:"history-aside"},[_c('div',{staticClass:"aside-group"},[(_vm.isSignedIn)?_c('div',{staticClass:"aside-section"},[_c('Dial')],1):_vm._e(),_c('div',{staticClass:"aside-section qr"},[_c('QRCode')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }